import { render } from "./EphemeridesTableHeader.vue?vue&type=template&id=05009444"
import script from "./EphemeridesTableHeader.vue?vue&type=script&lang=js"
export * from "./EphemeridesTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__